<script>
    import { apiURL } from '../../store.js'
    import { hslide } from '../../js/transitions.js'
    import { clamp } from '../../js/util.js'

    export let images
    export let color
    export let title

    let currIndex = 0
    const transitionParams = { duration: 400 }

    function setSlide (index) {
        currIndex = index
    }

    function incSlide (delta) {
        currIndex = clamp(currIndex + delta, 0, images.length - 1)
    }
</script>

<div class="extra-outer-wrapper" style="--pageColor: {color}">
    <div class="outer-wrapper">
        <div class="inner-wrapper">
            {#each images as image, id}
                {#if id === currIndex}
                    <div class="slide" in:hslide={transitionParams} out:hslide={transitionParams}>
                        <img src="{apiURL}{image.value.url}" alt="{title} {id}" />
                    </div>
                {/if}
            {/each}
            <div class="controls">
                <button on:click={() => incSlide(-1)}>
                    <svg
                        class="indicator"
                        style="fill: white; transform: rotate(180deg);"
                        data-name="Layer 1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 240.58 393.15"
                    >
                        <polygon points="240.58 196.58 0 393.15 0 0 240.58 196.58" />
                    </svg>
                </button>
                <button on:click={() => incSlide(1)}>
                    <svg
                        class="indicator"
                        style="fill: white;"
                        data-name="Layer 1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 240.58 393.15"
                    >
                        <polygon points="240.58 196.58 0 393.15 0 0 240.58 196.58" />
                    </svg>
                </button>
            </div>
        </div>
    </div>
</div>
<div class="dots">
    {#each images as image, i}
        <button
            class="dot"
            class:selected={currIndex == i}
            on:click={() => setSlide(i)}
        >
            {i + 1}
        </button>
    {/each}
</div>

<style lang="scss">
    button {
        background: rgba(0,0,0,0.2);
        color: #FFF;
        border-color: transparent;
        width: 2rem;
        height: 2rem;

        svg {
            height:1rem;
        }
    }

    button:hover {
        cursor: pointer;
        background: rgba(0,0,0,0.5);
    }

    .dots {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: -30px;
        margin-bottom: 30px;
    }

    .dot {
        width: 8px;
        height: 8px;
        background: #000;
        border-radius: 100%;
        font-size: 0;
        margin: 0.3rem;
        opacity: 0.3;
        z-index: 3;
    }

    .dot.selected {
        opacity: 1;
    }

    .extra-outer-wrapper {
        width: 100%;
        padding: 0.5rem;
        border: 2px solid var(--pageColor);
        background-color: transparent;
        box-sizing: border-box;
    }

    .outer-wrapper {
        width: 100%;
        padding: 0 0 60%;
        position: relative;
    }

    .inner-wrapper {
        height: 100%;
        width: 100%;
        display: flex;
        position: absolute;
    }

    .controls button:first-child {
        position: absolute;
        left: 0;
        top: calc(50% - 1.2rem);
    }

    .controls button:last-child {
        position: absolute;
        right: 0;
        top: calc(50% - 1.2rem);
    }

    .slide {
        flex: 1 0 auto;
        width: 100%;
        height: 100%;
        align-items: center;
        justify-content: center;
        display: flex;
        text-align: center;
        font-weight: bold;
        font-size: 2rem;
        color: white;

        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }

    .controls {
        text-align: center;
        width: 100%;
        display: block;
    }
</style>
